import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { EChartsOption } from 'echarts';
@Component({
  selector: 'app-dashboard-bar-chart',
  templateUrl: './dashboard-bar-chart.component.html',
  styleUrls: ['./dashboard-bar-chart.component.scss']
})
export class DashboardBarChartComponent implements OnInit,OnChanges {
  @Input()barChartData:any;  
  // @Input()barChartData1:any;  
  constructor() {
  }
  ngOnInit(){
  }
  ngOnChanges() {
    this.barChart = { ...this.barChart };
    this.barChart.xAxis['data'] = this.barChartData.map((item) => { return item?.['company']});
    this.barChart.series['data'] = this.barChartData.map((item) => { return item?.['license_count']});
    // this.barChart.xAxis['data'] = this.barChartData1?.map((item) => { return item?.['application']});
    // this.barChart.series['data'] = this.barChartData1?.map((item) => { return item?.['license_count']});
    if(this.barChartData.length == 0){
      this.barChart.series['data'].push('no data avilable');
    }
  }

  barChart:EChartsOption = {
    tooltip: {
      trigger: 'axis'
    },
    grid: {
      left: '3%',
      right: '2%',
      bottom: '6%',
      top:'4%',
      containLabel: true
    },
  xAxis: {
    data:[],
    name: 'Companies',
    nameGap: 20,
    nameLocation: 'middle',
    nameTextStyle: {
      color: "#1E3044",
      fontStyle: "normal",
      fontFamily: "am-Montserrat",
      fontWeight: "normal",
      fontSize: 12,
    },
    axisLabel: {
      // color: "#1E3044",
      fontStyle: "normal",
      fontFamily: "am-Montserrat",
      fontWeight: "normal",
      fontSize: 10,
    }
  
  },
  yAxis: {
    name: 'Count of License',
    nameLocation: 'middle',
    minInterval:1,
    nameGap: 25,
    type: 'value',
    axisLabel: {
      // color: "#1E3044",
      fontStyle: "normal",
      fontFamily: "am-Montserrat",
      fontWeight: "normal",
      fontSize: 10,
    },
    nameTextStyle: {
      color: "#1E3044",
      fontStyle: "normal",
      fontFamily: "am-Montserrat",
      fontWeight: "normal",
      fontSize: 12,
    }
    
  },
  series: 
    {
      barWidth:"20px",
      itemStyle:{color:"#006699"},
      data:[],
      type: 'bar'
    }
  
};
  
}
